import React from 'react';
import { Modal, Button, Form, Select, Switch } from 'antd';

import SelectPlaceHolder from "../../../components/SelectPlaceHolder";

export default class ImprimirModal extends React.Component {
    render() {
        return (
            <Modal
                title={"Imprimir"}
                visible={this.props.visible}
                onCancel={this.props.onClose}
                destroyOnClose={true}
                style={{ top: 30 }}
                width={1200}
                footer={null}
            >
                <Form>


                    <div className="row">
                        <div className="col-md-4">
                            <Select
                                showSearch labelInValue
                                value={
                                    this.props.formValues.idFormato ?
                                        { key: this.props.formValues.idFormato } : undefined
                                }
                                placeholder={<SelectPlaceHolder label="Seleccione Formato" />}
                                onChange={(option) => this.props.onChange(option.key)}
                                optionFilterProp="children"
                            >
                                {this.props.formValues.formatos.map(item => (
                                    <Select.Option value={item.id} key={item.id}>{item.nombre}</Select.Option>
                                ))}
                            </Select>
                        </div>
                        <div className="col-md-5">

                            {this.props.formValues.idFormato == 2 ?
                                <Switch
                                    defaultChecked={this.props.formValues.isEpson}
                                    disabled={this.props.formValues.idFormato == 0 ? true : false}
                                    checkedChildren="EPSON"
                                    unCheckedChildren="OTROS"
                                    onChange={(e) => this.props.onSwitch(e)}
                                /> : null
                            }

                        </div>


                        <div className="col-md-3">
                            <div className="row">



                                <div className="gutter-row mr-10" sm={24} md={12} lg={4}>
                                    <Form.Item>
                                        <Button
                                            key="send"
                                            type="primary"
                                            icon="close"
                                            onClick={this.props.onClose}
                                        >
                                            Cerrar
                                        </Button>


                                    </Form.Item>
                                </div>

                                <div className="gutter-row mr-10" sm={24} md={12} lg={4}>
                                    <Form.Item>
                                        <Button
                                            key="print"
                                            type="primary"
                                            icon="download"
                                            //hidden={true}
                                            onClick={this.props.onDownload}
                                        >
                                            Descargar
                                        </Button>
                                    </Form.Item>
                                </div>
                            </div>
                        </div>



                    </div>


                    <br />
                    <div className="row">
                        <div className="col-md-12 form-group">
                            <embed
                                src={this.props.formValues.file}
                                // src={this.props.formValues.file+ '#view=fitH'}
                                style={{ width: '100%', height: 600 }}
                                type="application/pdf"
                            />
                        </div>
                    </div>
                </Form>
            </Modal>
        );
    }
}